import React, { useEffect, useRef } from 'react'
import { Col, Row, Spinner } from "reactstrap";
import {
    DropdownToggle,
    DropdownMenu,
    Dropdown
} from "reactstrap";
import { ReactComponent as SearchIcon } from "../../../assets/utils/images/svgs/search.svg";
import axiosInstance from 'Api';
import { Link } from 'react-router-dom';

const SearchModal = () => {
    const [modalOpen, setModalOpen] = React.useState(false);
    const dropdownRef = useRef(null);
    const serachTimer = useRef(null);
    const [search, setSearch] = React.useState('');
    const [communityList, setCommunityList] = React.useState([]);
    const [selectedCommunity, setSelectedCommunity] = React.useState('');
    const [adminList, setAdminList] = React.useState([]);
    const [schoolList, setSchoolList] = React.useState([]);
    const [substitutionsList, setSubstitutionsList] = React.useState([]);
    const [loading, setLoading] = React.useState(false);

    const toggleModal = () => setModalOpen(prev => !prev);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setModalOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    const handleSearch = (value) => {
        setSelectedCommunity('');
        setLoading(true);
        setSearch(value)

        serachTimer.current = setTimeout(() => {
            searchApiCall(value)
        }, 500);
    };

    const searchApiCall = (value = '', type = null, typeValue = null) => {
        let searchText = value;
        if (/^\d+$/.test(value)) {
            if (value.startsWith('0')) {
                searchText = value.toString();
            } else {
                searchText = Number(value);
            }
        }
        axiosInstance.post('/search-list', {
            search: searchText,
            ...type === 'iCommunityId' && typeValue !== '' ? { iCommunityId: typeValue } : null
        }).then((response) => {
            if (response?.data?.status) {
                response.data.data?.communities ? setCommunityList(response.data.data?.communities) : setCommunityList([]);
                response.data.data?.adminsList ? setAdminList(response.data.data?.adminsList) : setAdminList([]);
                response.data.data?.schools ? setSchoolList(response.data.data?.schools) : setSchoolList([]);
                response.data.data?.substitutions ? setSubstitutionsList(response.data.data?.substitutions) : setSubstitutionsList([]);
                setLoading(false);
            }
        }).catch((err) => console.error(err));
    }

    return (
        <div className="ps-0 position-relative header-search" ref={dropdownRef}>
            <div className="widget-content p-0">
                <div className="widget-content-wrapper">
                    <div className="widget-content-left">
                        <Dropdown isOpen={modalOpen} toggle={function noRefCheck() { }}>
                            <DropdownToggle data-toggle="dropdown"
                                tag="span" className="p-0">
                                {
                                    !modalOpen ?
                                        <div className={`support-icon`} onClick={toggleModal} >
                                            <SearchIcon className="search-icon" />
                                        </div> :
                                        <div className="melder-search search-input" onClick={(e) => e.stopPropagation()}>
                                            <input
                                                placeholder="Zoeken"
                                                value={search}
                                                onChange={(e) => handleSearch(e.target.value)}
                                            />
                                            <SearchIcon />
                                        </div>
                                }
                            </DropdownToggle>
                            {
                                modalOpen ?
                                    <DropdownMenu end className="rm-pointers dropdown-menu-lg">
                                        {loading ? <div className='d-flex justify-content-center'><Spinner size="sm" color="primary" /> </div> :
                                            <div className='body-search'>
                                                <div className='mb-4'>
                                                    <h5>Filters</h5>
                                                    <select
                                                        className="search-dropdown"
                                                        value={selectedCommunity}
                                                        onChange={(e) => {
                                                            setSelectedCommunity(e.target.value);
                                                            searchApiCall(search, 'iCommunityId', e.target.value);
                                                        }}
                                                    >
                                                        <option value="" >
                                                            Alle besturen
                                                        </option>
                                                        {communityList?.map((item) => (
                                                            <option key={item.iCommunityId} value={item.iCommunityId}>
                                                                {item.vCommunityName}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                                {
                                                    /^\d+$/.test(search) &&  <div className='mb-4'>
                                                    <h5>Verzoeken</h5>
                                                    {
                                                        substitutionsList.length > 0 ? (
                                                            <Row className='ms-1'>
                                                                {substitutionsList.map((item) => (
                                                                    <Col className='col-6' key={item}>
                                                                        <p>{item}</p>
                                                                    </Col>
                                                                ))}
                                                            </Row>
                                                        ) : (
                                                            <p className='ms-3'>Geen resultaten</p>
                                                        )
                                                    }
                                                </div>
                                                }
                                               
                                                <div className='mb-4'>
                                                    <h5>Personen</h5>
                                                    {
                                                        adminList.length > 0 ? (
                                                            <div className='list'>
                                                                {adminList.map((item) => (
                                                                    <div className='mb-3' key={item.iAdminId}>
                                                                        <Link
                                                                            to={`/gebruikers/${item.iAdminId}?tab=Profiel`}
                                                                            target="_blank"
                                                                            rel="noopener noreferrer"
                                                                        >
                                                                            {[...[
                                                                                item?.vFirstName,
                                                                                item?.vMiddleName,
                                                                                item?.vLastName
                                                                            ].filter(Boolean), item?.vCity].filter(Boolean).join(' - ')}

                                                                        </Link>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        ) : (
                                                            <p className='ms-3'>Geen resultaten</p>
                                                        )
                                                    }
                                                </div>
                                                {
                                                    !/^\d+$/.test(search) &&
                                                    <div>
                                                        <h5>Scholen</h5>
                                                        {
                                                            schoolList.length > 0 ?
                                                                <div className='list'>
                                                                    {schoolList.map((item) => (
                                                                        <div className='mb-3'>
                                                                            <Link
                                                                                to={`/c-instellingen/scholen/${item.vCommunityName}/${item.iSchoolId}`}
                                                                                target="_blank"
                                                                                rel="noopener noreferrer"
                                                                            >{[
                                                                                [item.vSchoolName].filter(Boolean).join(' '),
                                                                                item?.vCommunityName
                                                                            ].filter(Boolean).join('- ')}
                                                                            </Link>
                                                                        </div>
                                                                    ))}
                                                                </div> :
                                                                <p className='ms-3'>Geen resultaten</p>
                                                        }
                                                    </div>
                                                }
                                            </div>}
                                    </DropdownMenu> : null
                            }
                        </Dropdown>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default SearchModal;